import {AppLayout} from '@/modules/layout/app-layout/components/app-layout'
import {MobileLayout} from '@/modules/layout/app-layout/components/mobile-layout'
import {Tabs, useBreakpointValue} from '@chakra-ui/react'
import {createFileRoute, Outlet, redirect, useNavigate, useLocation} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'

export const Route = createFileRoute('/stocks')({
  component: StocksLayout,
  beforeLoad: ({location}) => {
    if (location.pathname === '/stocks') throw redirect({to: '/stocks/batches'})
  },
})

function StocksLayout() {
  const location = useLocation()
  const navigate = useNavigate()
  const {t} = useTranslate('common')
  const isMobile = useBreakpointValue({base: true, md: false}) ?? false

  const children = (
    <Tabs.Root value={location.pathname} onValueChange={({value}) => navigate({to: value})} width="100%" height="100%">
      <Tabs.Content
        value={location.pathname}
        display="flex"
        flexDirection="column"
        width="100%"
        height="100%"
        py="0"
        gap="0"
      >
        <Outlet />
      </Tabs.Content>
    </Tabs.Root>
  )

  return isMobile ? (
    <MobileLayout title={t('stocks')}>{children}</MobileLayout>
  ) : (
    <AppLayout hideSideDrawer>{children}</AppLayout>
  )
}
